import React, { useState } from 'react';
import PropTypes from 'prop-types';
import BranchDisclaimerModal from '../branch-disclaimer-modal';

const BranchOfferText = ({ offer, className }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);

	const renderDisclaimerNumber = (value) => {
		if (value === '2' && offer?.disclaimer1 === offer?.disclaimer2) return '1';

		if (value === '3' && offer?.disclaimer1 === offer?.disclaimer3) {
			return '1';
		} else if (value === '3' && offer?.disclaimer2 === offer?.disclaimer3) {
			return '2';
		}

		return value;
	};

	const onModalTrigger = () => setIsModalOpen(!isModalOpen);

	return (
		<div className={`branch-offer-text ${className || ''}`}>
			{!offer?.hideNameOnClient && offer?.name && <p className='mb-4 text-white'>{offer.name}</p>}
			{offer?.option1 && (
				<p className='m-0 text-white'>
					{offer.option1}
					<sup>
						<button
							className='underline hover:no-underline focus:no-underline'
							onClick={onModalTrigger}
						>
							1
						</button>
					</sup>
				</p>
			)}
			{offer?.conjunction1 && <p className='text-subtitle mb-1 mt-1.5 text-white'>{offer.conjunction1}</p>}
			{offer?.option2 && (
				<p className='m-0 text-white'>
					{offer.option2}
					<sup>
						<button
							className='underline hover:no-underline focus:no-underline'
							onClick={onModalTrigger}
						>
							{renderDisclaimerNumber('2')}
						</button>
					</sup>
				</p>
			)}
			{offer?.conjunction2 && <p className='text-subtitle mb-1 mt-1.5 text-white'>{offer.conjunction2}</p>}
			{offer?.option3 && (
				<p className='m-0 text-white'>
					{offer.option3}
					<sup>
						<button
							className='underline hover:no-underline focus:no-underline'
							onClick={onModalTrigger}
						>
							{renderDisclaimerNumber('3')}
						</button>
					</sup>
				</p>
			)}

			<BranchDisclaimerModal
				isOpen={isModalOpen}
				onClose={onModalTrigger}
				disclaimer={offer}
			/>
		</div>
	);
};

BranchOfferText.propTypes = {
	offer: PropTypes.object,
	className: PropTypes.string,
};

export default BranchOfferText;
